import React, {useEffect} from 'react';
import {CommonLayout} from "../../layouts/CommonLayout/CommonLayout";
import {Grid, Paper, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {useFormik} from "formik";
import Button from "@material-ui/core/Button";
import {useDispatch, useSelector} from "react-redux";
import {
    getProfile,
    loadProfileData,
    updatePassword,
    updateProfileData
} from "../../redux/reducers/user-profile-reducer.js";
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ChangePasswordDialog from "../../components/ChangePasswordDialog/ChangePasswordDialog.jsx";
import {useDialog} from "../../hooks/useDialog.js";
import {FormTable} from "../../components/FormTable/FormTable.jsx";

const useStyles = makeStyles((theme) => ({
    paper: {
        width: '100%',
        padding: theme.spacing(1)
    },
    avatar: {
        fontSize: theme.spacing(10)
    }
}))

const personalInfoConfig = [
    {label: 'Фамилия', id: 'last_name'},
    {label: 'Имя', id: 'first_name'},
    {label: 'Отчество', id: 'mid_name'},
    {label: 'Должность', id: 'appointment'},
    {label: 'Организация', id: 'organization'},
    {label: 'Логин', id: 'username'},
    {label: 'Номер телефона', id: 'phone_number'},
    {label: 'e-mail', id: 'email'},
]

const fullNameCasesConfig = [
    {label: 'ФИО кому', id: 'full_name_to_whom'},
    {label: 'ФИО кем', id: 'full_name_by_whom'},
    {label: 'ФИО кого', id: 'full_name_whom'},
]

const appointmentCasesConfig = [
    {label: 'Должность кому', id: 'appointment_to_whom'},
    {label: 'Должность кем', id: 'appointment_by_whom'},
    {label: 'Должность кого', id: 'appointment_whom'},
]

const ProfilePage = () => {
    const classes = useStyles()

    const dispatch = useDispatch()

    const {user, loading} = useSelector(getProfile)

    const {
        open: passwordDialogOpen,
        handleOpen: passwordDialogHandleOpen,
        handleClose: passwordDialogHandleClose
    } = useDialog()

    const handleSubmit = async (values) => {
        await dispatch(updateProfileData({
            ...values,
            full_name: `${values.last_name} ${values.first_name.slice(0, 1)}.${values.mid_name.slice(0, 1)}.`
        }))
        await dispatch(loadProfileData)
    }

    const {submitForm, getFieldProps, getFieldMeta, setValues} = useFormik({
        initialValues: {
            id: undefined,
            username: undefined,
            first_name: undefined,
            last_name: undefined,
            email: undefined,
            mid_name: undefined,
            appointment: undefined,
            phone_number: undefined,
            organization: undefined,
            appointment_to_whom: undefined,
            appointment_by_whom: undefined,
            appointment_whom: undefined,
            full_name_to_whom: undefined,
            full_name_by_whom: undefined,
            full_name_whom: undefined,
            full_name: undefined,
        },
        onSubmit: handleSubmit
    })

    useEffect(() => {
        if (user) {
            setValues({
                id: user.id,
                username: user.username,
                first_name: user.first_name,
                last_name: user.last_name,
                email: user.email,
                mid_name: user.mid_name,
                appointment: user.appointment,
                phone_number: user.phone_number,
                organization: user.organization,
                appointment_to_whom: user.appointment_to_whom,
                appointment_by_whom: user.appointment_by_whom,
                appointment_whom: user.appointment_whom,
                full_name_to_whom: user.full_name_to_whom,
                full_name_by_whom: user.full_name_by_whom,
                full_name_whom: user.full_name_whom,
                full_name: user.full_name,
            })
        }
    }, [user])

    return (
        <CommonLayout>
            <ChangePasswordDialog
                open={passwordDialogOpen}
                onClose={passwordDialogHandleClose}
                submitCallback={(values, onSuccess) => dispatch(updatePassword(user.id, values, onSuccess))}

            />
            <Grid container direction={'column'} spacing={4}>
                <Grid container item spacing={4}>
                    <Grid container item xs={6}>
                        <Grid item xs>
                            <Typography variant={'h3'}>{user?.last_name}</Typography>
                            <Typography variant={'h3'}>{user?.first_name}</Typography>
                            <Typography variant={'h3'}>{user?.mid_name}</Typography>
                            <Typography variant={'h5'}>{user?.appointment}</Typography>
                            <Typography variant={'h5'}>{user?.organization}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container item xs={6}>
                        <Grid item container justifyContent={'space-between'} alignItems={'center'}>
                            <Grid item>
                                <Typography variant={'h6'}>Личная информация</Typography>
                            </Grid>
                            <Grid item>
                                <Button size={'small'} startIcon={<VpnKeyIcon/>} onClick={passwordDialogHandleOpen}>
                                    Сменить пароль
                                </Button>
                            </Grid>
                        </Grid>
                        <Paper className={classes.paper}>
                            <FormTable config={personalInfoConfig} getFieldProps={getFieldProps}
                                       getFieldMeta={getFieldMeta}/>
                        </Paper>
                    </Grid>
                </Grid>
                <Grid container item spacing={4}>
                    <Grid item xs={6}>
                        <Typography variant={'h6'}>Склонение ФИО</Typography>
                        <Paper className={classes.paper}>
                            <FormTable config={fullNameCasesConfig} getFieldProps={getFieldProps}
                                       getFieldMeta={getFieldMeta}/>
                        </Paper>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant={'h6'}>Склонение должности</Typography>
                        <Paper className={classes.paper}>
                            <FormTable config={appointmentCasesConfig} getFieldProps={getFieldProps}
                                       getFieldMeta={getFieldMeta}/>
                        </Paper>
                    </Grid>
                </Grid>
                <Grid container item justifyContent={'flex-end'}>
                    <Button
                        variant={'contained'}
                        color={'primary'}
                        onClick={submitForm}
                        disabled={loading || !Boolean(user)}
                    >
                        Сохранить
                    </Button>
                </Grid>
            </Grid>
        </CommonLayout>
    );
};

export default ProfilePage;